var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRightQuarterCircleOfGate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C4.2023 5.01119e-08 8.36345 0.827705 12.2459 2.43586C16.1283 4.04401 19.6559 6.40111 22.6274 9.37259C25.5989 12.3441 27.956 15.8717 29.5641 19.7541C31.1723 23.6366 32 27.7977 32 32L0 32V0Z",
    fill: "#007A9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightQuarterCircleOfGate);
export default __webpack_public_path__ + "static/media/TopRightQuarterCircleOfGate.4372c574.svg";
export { ForwardRef as ReactComponent };